import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { WorkingStationLiveComponent } from './working-station-live/working-station-live.component';
import { AuthGuardService } from './service/core/auth-guard.service';
import { DelayOrderComponent } from './delay-order/delay-order.component';
import { NewCustomerRegistrationComponent } from './reports-analytics/new-customer-registration/new-customer-registration.component';
import { TopActiveCustomerComponent } from './reports-analytics/top-active-customer/top-active-customer.component';
import { CustomerBehaviorComponent } from './reports-analytics/customer-behavior/customer-behavior.component';
import { OrdersOverTimeComponent } from './reports-analytics/orders-over-time/orders-over-time.component';
import { ServicePerformanceComponent } from './reports-analytics/service-performance/service-performance.component';
import { TeamPerformanceComponent } from './reports-analytics/team-performance/team-performance.component';
import { RDCPrimaryDataComponent } from './rdc/rdcprimary-data/rdcprimary-data.component';
import { WorkFlowComponent } from './common/work-flow/work-flow.component';

const routes: Routes = [
  // { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuardService] },
  { path: 'workStation', component: WorkingStationLiveComponent, canActivate: [AuthGuardService] },
  { path: 'delayOrder', component: DelayOrderComponent, canActivate: [AuthGuardService] },
  { path: 'NewCustomerRegistration', component: NewCustomerRegistrationComponent, canActivate: [AuthGuardService] },
  { path: 'TopActiveCUstomer', component: TopActiveCustomerComponent, canActivate: [AuthGuardService] },
  { path: 'CustomerBehavior', component: CustomerBehaviorComponent, canActivate: [AuthGuardService] },
  { path: 'OrdersOvertime', component: OrdersOverTimeComponent, canActivate: [AuthGuardService] },
  { path: 'ServicePerformance', component: ServicePerformanceComponent, canActivate: [AuthGuardService] },
  { path: 'TeamPerformance', component: TeamPerformanceComponent, canActivate: [AuthGuardService] },
  { path: 'RDCPrimaryData', component: RDCPrimaryDataComponent, canActivate: [AuthGuardService] },
  { path: 'WorkFlow', component: WorkFlowComponent, canActivate: [AuthGuardService] },
  { path: 'common', loadChildren: () => import('./common/common.module').then(m => m.AppCommonModule), canActivate: [AuthGuardService] },
  { path: '', loadChildren: () => import('./shared/customer-layout/home/home.module').then(m => m.HomeModule), canActivate: [AuthGuardService] },
  { path: 'widgets', loadChildren: () => import('./widgets/widgets.module').then(m => m.WidgetsModule) },
  { path: 'layout', loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule) },
  { path: 'basic-ui', loadChildren: () => import('./basic-ui/basic-ui.module').then(m => m.BasicUiModule) },
  { path: 'advanced-ui', loadChildren: () => import('./advanced-ui/advanced-ui.module').then(m => m.AdvancedUiModule) },
  { path: 'charts', loadChildren: () => import('./charts/charts.module').then(m => m.ChartsDemoModule) },
  { path: 'forms', loadChildren: () => import('./forms/form.module').then(m => m.FormModule) },
  { path: 'editors', loadChildren: () => import('./editors/editors.module').then(m => m.EditorsModule) },
  { path: 'tables', loadChildren: () => import('./tables/tables.module').then(m => m.TablesModule) },
  { path: 'icons', loadChildren: () => import('./icons/icons.module').then(m => m.IconsModule) },
  { path: 'maps', loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule) },
  { path: 'general-pages', loadChildren: () => import('./general-pages/general-pages.module').then(m => m.GeneralPagesModule) },
  { path: 'ecommerce', loadChildren: () => import('./ecommerce/ecommerce.module').then(m => m.EcommerceModule) },
  { path: 'apps', loadChildren: () => import('./apps/apps.module').then(m => m.AppsModule) },
  { path: 'error', loadChildren: () => import('./error-pages/error-pages.module').then(m => m.ErrorPagesModule) },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
    data: { breadcrumb: { skip: true } }
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule),
    data: { breadcrumb: { skip: true } }
  },
  {
    path: 'customer',
    loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
    data: { breadcrumb: { skip: true } }
  },
  {
    path: 'order',
    loadChildren: () => import('./order/order.module').then(m => m.OrderModule),
    data: { breadcrumb: { skip: true } }
  },
  {
    path: 'configuration',
    loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule),
    data: { breadcrumb: { skip: true } }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
